<template>
  <div
    v-if="showComponent"
    :class="['see-more-element small-12', columnsClass]"
    data-test-element-root
  >
    <a class="row" :href="element.link.url" @click="dispatchClickTrackingEvent(element.link.text)">
      <div class="column small-3 medium-12 circle-arrow-container">
        <span class="button circle-arrow" />
      </div>

      <div class="column small-9 medium-12">
        <p class="text-element">
          <span v-html="element.link.text" />
          <span class="list-nav-arrow">&gt;</span>
        </p>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import NavigationListSeeMoreLink from '../interfaces/NavigationListSeeMoreLink';

export default defineComponent({
  name: 'NavigationListSeeMoreLink',
  props: {
    element: {
      type: Object as PropType<NavigationListSeeMoreLink>,
      default() {
        return {
          link: {
            url: '',
            next: '',
            text: '',
            abstract: '',
            cssClass: '',
            isActive: false,
            isOpen: false,
            target: '',
            editorField: ''
          }
        } as NavigationListSeeMoreLink;
      }
    },
    description: {
      type: String,
      default() {
        return '';
      }
    },
    columnsClass: {
      type: String,
      default() {
        return 'medium-4 large-2';
      }
    }
  },
  computed: {
    showComponent(): boolean {
      return this.element !== null && this.element.link !== null && this.element.link.url !== '';
    }
  },
  methods: {
    dispatchClickTrackingEvent(title: string) {
      this.$store.dispatch('Events/register', {
        event: 'navigation-list-click-element',
        id: 'navigationList',
        vm: {
          description: this.description,
          label: title
        }
      });
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
@import 'src/styles/colors.scss';

.see-more-element {
  margin-bottom: rem-calc(30);
  text-align: center;

  @media #{$medium-up} {
    &:hover {
      transform: scale(1.05);
      transition: transform 250ms;
    }
  }

  @media #{$small-only} {
    padding: rem-calc(10.7) rem-calc(10);
    text-align: left;
    border: 1.5px solid $disturber-color;
    border-radius: rem-calc(15);

    .circle-arrow {
      margin-left: rem-calc(8);
    }
  }

  a {
    text-decoration: none;
    padding: 0 rem-calc(11);

    &:hover {
      .circle-arrow {
        background-color: $primary-color;
      }

      span,
      p {
        color: $primary-color;
      }
    }

    .circle-arrow-container {
      height: rem-calc(56);
    }

    span {
      color: $disturber-color;
      font-size: rem-calc(26);
    }

    .circle-arrow {
      margin-top: rem-calc(8);
      margin-bottom: rem-calc(4);
    }

    .text-element {
      margin-top: rem-calc(10);
    }

    .list-nav-arrow {
      margin-left: rem-calc(5);
    }
  }
}
</style>
